export default __webpack_public_path__ + "static/media/35.69b3b31e.jpg";